import React from 'react';
import styles from './not-moderated-cards.module.scss';
import Emoji from '@/assets/images/emoji-last-card.png';
import { Button, Typography } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import { RemoderationIcon } from '@/assets/icons';

interface Props {}

export const NotModeratedCards: React.FC<Props> = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <RemoderationIcon
                    className={styles.remoderationCardIcon}
                    width={56}
                    height={56} />
                <Typography
                    fontWeight="bold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    Отредактируй свои данные,<br />чтобы пройти модерацию
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    После прохождения проверки твой профиль будет показываться в ленте и тебя смогут лайкать
                </Typography>
                <Button
                    className={styles.button}
                    textColor="black"
                    typeColor="white"
                    isLink
                    to={routesApp.profileEdit}>
                    Перейти в профиль
                </Button>
            </div>
        </div>
    );
};
